import type { Citation } from "@/lib/citations";

/**
 * The primary sources behind the free risk matrix calculator
 * (/free/risk-matrix-calculator), read on the accessed date. HSE's "Managing
 * risks and risk assessment at work" pages back the two statements the page
 * makes about the law: the minimum is to decide how likely harm is and how
 * serious it could be, and HSE's own template has no scoring matrix.
 */
const ACCESSED = "2026-10-31";

export const HSE_RISK_OVERVIEW_URL = "https://www.hse.gov.uk/simple-health-safety/risk/index.htm";
export const HSE_RISK_STEPS_URL = "https://www.hse.gov.uk/simple-health-safety/risk/steps-needed-to-manage-risk.htm";
export const HSE_RISK_TEMPLATE_URL =
  "https://www.hse.gov.uk/simple-health-safety/risk/risk-assessment-template-and-examples.htm";
export const MHSWR_REG_3_URL = "https://www.legislation.gov.uk/uksi/1999/3242/regulation/3";
export const MHSWR_NI_URL = "https://www.legislation.gov.uk/nisr/2000/388/contents";

export const RISK_MATRIX_SOURCES: readonly Citation[] = [
  {
    title: "Managing risks and risk assessment at work: overview",
    url: HSE_RISK_OVERVIEW_URL,
    publisher: "Health and Safety Executive",
    accessedAt: ACCESSED,
  },
  {
    title: "Managing risks and risk assessment at work: steps needed to manage risk",
    url: HSE_RISK_STEPS_URL,
    publisher: "Health and Safety Executive",
    accessedAt: ACCESSED,
  },
  {
    title: "Managing risks and risk assessment at work: risk assessment template and examples",
    url: HSE_RISK_TEMPLATE_URL,
    publisher: "Health and Safety Executive",
    accessedAt: ACCESSED,
  },
  {
    title: "The Management of Health and Safety at Work Regulations 1999, regulation 3 (Risk assessment)",
    url: MHSWR_REG_3_URL,
    publisher: "legislation.gov.uk",
    accessedAt: ACCESSED,
  },
  {
    title: "The Management of Health and Safety at Work Regulations (Northern Ireland) 2000",
    url: MHSWR_NI_URL,
    publisher: "legislation.gov.uk",
    accessedAt: ACCESSED,
  },
];
